export default __webpack_public_path__ + "static/center-kr-5c191d90177278e6f943d376b52f450b.webp";